function Message2Icon() {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.9999 26.6104C13.1949 26.6104 12.4366 26.202 11.8999 25.4904L10.1499 23.157C10.1149 23.1104 9.97492 23.052 9.91659 23.0404H9.33325C4.46825 23.0404 1.45825 21.722 1.45825 15.1654V9.33203C1.45825 4.17536 4.17659 1.45703 9.33325 1.45703H18.6666C23.8233 1.45703 26.5416 4.17536 26.5416 9.33203V15.1654C26.5416 20.322 23.8233 23.0404 18.6666 23.0404H18.0833C17.9899 23.0404 17.9083 23.087 17.8499 23.157L16.0999 25.4904C15.5633 26.202 14.8049 26.6104 13.9999 26.6104ZM9.33325 3.20703C5.15659 3.20703 3.20825 5.15536 3.20825 9.33203V15.1654C3.20825 20.4387 5.01659 21.2904 9.33325 21.2904H9.91659C10.5116 21.2904 11.1883 21.6287 11.5499 22.107L13.2999 24.4404C13.7083 24.977 14.2916 24.977 14.6999 24.4404L16.4499 22.107C16.8349 21.5937 17.4416 21.2904 18.0833 21.2904H18.6666C22.8433 21.2904 24.7916 19.342 24.7916 15.1654V9.33203C24.7916 5.15536 22.8433 3.20703 18.6666 3.20703H9.33325Z"
        fill="#657892"
      />
      <path
        d="M13.9999 14.0013C13.3466 14.0013 12.8333 13.4763 12.8333 12.8346C12.8333 12.193 13.3583 11.668 13.9999 11.668C14.6416 11.668 15.1666 12.193 15.1666 12.8346C15.1666 13.4763 14.6533 14.0013 13.9999 14.0013Z"
        fill="#657892"
      />
      <path
        d="M18.6667 14.0013C18.0133 14.0013 17.5 13.4763 17.5 12.8346C17.5 12.193 18.025 11.668 18.6667 11.668C19.3083 11.668 19.8333 12.193 19.8333 12.8346C19.8333 13.4763 19.32 14.0013 18.6667 14.0013Z"
        fill="#657892"
      />
      <path
        d="M9.33317 14.0013C8.67984 14.0013 8.1665 13.4763 8.1665 12.8346C8.1665 12.193 8.6915 11.668 9.33317 11.668C9.97484 11.668 10.4998 12.193 10.4998 12.8346C10.4998 13.4763 9.9865 14.0013 9.33317 14.0013Z"
        fill="#657892"
      />
    </svg>
  );
}

export default Message2Icon;
